import { render, staticRenderFns } from "./SimilarList.vue?vue&type=template&id=62431d65"
import script from "./SimilarList.vue?vue&type=script&lang=js"
export * from "./SimilarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports